(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("soqlParserJs", [], factory);
	else if(typeof exports === 'object')
		exports["soqlParserJs"] = factory();
	else
		root["soqlParserJs"] = factory();
})(typeof self !== 'undefined' ? self : this, () => {
return 